import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizeRouterHttpLoader } from '@gilsdav/ngx-translate-router-http-loader';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { LocalizeRouterSettings } from '@gilsdav/ngx-translate-router';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function createTranslateRouterLoader(translate: TranslateService, location: Location, settings: LocalizeRouterSettings, http: HttpClient) {
  const isServer = typeof window === 'undefined';
  const localesFilePath = isServer ? 'http://localhost:4200/assets/i18n/locales.json' : '/assets/i18n/locales.json';
  return new LocalizeRouterHttpLoader(translate, location, settings, http, localesFilePath);
}
